import { DONATE_CONFIG } from "@/config/donate";

export const HostingMeter = ({ onDonate }) => {
  const { show, monthlyCostUsd, receivedThisMonthUsd } = DONATE_CONFIG.hosting;
  if (!show) return null;
  const pct = Math.min(100, Math.round((receivedThisMonthUsd / Math.max(1, monthlyCostUsd)) * 100));

  return (
    <div
      data-testid="hosting-meter"
      className="border border-white/10 bg-[#0a0a0a] p-6"
    >
      <div className="flex items-baseline justify-between mb-3">
        <div className="text-[10px] uppercase tracking-[0.3em] text-[color:var(--accent-matrix)]">// hosting meter // this month</div>
        <div className="text-[10px] uppercase tracking-widest text-neutral-500">transparency</div>
      </div>
      <div className="flex items-end justify-between mb-3">
        <div>
          <div className="font-display font-bold text-2xl">
            ${receivedThisMonthUsd.toLocaleString()}
            <span className="text-neutral-500 text-base"> / ${monthlyCostUsd.toLocaleString()}</span>
          </div>
          <div className="text-xs text-neutral-400 mt-1">
            {pct}% of monthly hosting + AI credits covered
          </div>
        </div>
        <button
          data-testid="hosting-meter-donate"
          onClick={onDonate}
          className="bg-[color:var(--accent-amber)] text-black px-4 py-2 text-[10px] uppercase tracking-widest font-bold hover:bg-white duration-150"
          style={{ transitionProperty: "background-color" }}
        >
          chip in
        </button>
      </div>
      <div className="h-2 bg-black border border-white/10 relative overflow-hidden">
        <div
          className="h-full bg-[color:var(--accent-amber)]"
          style={{ width: `${pct}%`, transition: "width 400ms ease-out" }}
        />
      </div>
      <p className="text-[10px] text-neutral-500 mt-3">
        Costs are estimated. Excess donations roll to next month or model API credits. Updates manually. No hidden fees.
      </p>
    </div>
  );
};
